import { useSyncAcwAfterVoiceSessionEnd } from '@/shared/hooks/useSyncAcwAfterVoiceSessionEnd';
/**
 * Keeps toolbar ACW (`isPhonePause` / `phonePauseEnd`) in sync after any voice session ends.
 * Mounted once under {@link SipCallProvider} so hangup from toolbar, incoming modal, softphone,
 * or remote BYE all refetch profile — not only when the softphone dialog is open.
 */
export function SipVoiceSessionAcwSync() {
    useSyncAcwAfterVoiceSessionEnd();
    return null;
}
